export type APIResponse<T extends {}> =
    | {
          ok: true;
          status: number;
          data?: T;
      }
    | {
          ok: false;
          status: number;
          error: string;
          message: string;
      };

export async function api<T extends {}>(
    path: string,
    options?: RequestInit
): Promise<APIResponse<T>> {
    const response = await fetch(`/api/${path}`, options).then((res) => res);
    const json = await response.json();

    if (!response.ok) {
        return {
            ok: response.ok,
            status: response.status,
            error: json.errorName,
            message: json.message,
        };
    }

    return {
        ok: response.ok,
        status: response.status,
        data: json,
    } satisfies APIResponse<T>;
}
